import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57592833"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "服务订单" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        placeholder: "关键字",
        value: _ctx.searches.keywords,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
        style: {"width":"200px"}
      }, null, 8, ["value"]),
      _createVNode(_component_a_button, {
        style: {"margin-left":"10px"},
        type: "primary",
        onClick: _ctx.onSearch
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        style: {"margin-left":"10px"},
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_table, {
        dataSource: _ctx.list,
        columns: _ctx.columns,
        bordered: "",
        pagination: _ctx.pagination,
        onChange: _ctx.handleTableChange,
        style: {"margin-top":"10px"}
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.key === 'shop_name' && record.info !== null )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(record.info.goods_name), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'goods_num' && record.info !== null )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(record.info.goods_num), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'shopName' && record.info !== null )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(record.shop.name), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'goods_price' && record.info !== null )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(record.info.goods_price), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'user_name' )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(record.user.nickname), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'order_status')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                (record.order_status == 0 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "待付款"))
                  : _createCommentVNode("", true),
                (record.order_status == 1 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "有效中"))
                  : _createCommentVNode("", true),
                (record.order_status == 2 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "已完成（已使用）"))
                  : _createCommentVNode("", true),
                (record.order_status == 3 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "已关闭 "))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'pay_way')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (record.pay_way == 1 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "微信支付"))
                  : _createCommentVNode("", true),
                (record.pay_way == 2 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "支付宝支付"))
                  : _createCommentVNode("", true),
                (record.pay_way == 3 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "余额支付 "))
                  : _createCommentVNode("", true),
                (record.pay_way == 4 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "线下支付"))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'pay_status')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                (record.pay_status == 0 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "待支付"))
                  : _createCommentVNode("", true),
                (record.pay_status == 1 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, "已支付"))
                  : _createCommentVNode("", true),
                (record.pay_status == 2 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, "已退款"))
                  : _createCommentVNode("", true),
                (record.pay_status == 3 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "拒绝退款 "))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'order_type')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                (record.order_type == 7 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "会员类订单"))
                  : _createCommentVNode("", true),
                (record.order_type == 6 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, "资讯培训"))
                  : _createCommentVNode("", true),
                (record.order_type == 5 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, "课程"))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'refund_status')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                (record.refund_status == 0 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, "未退款"))
                  : _createCommentVNode("", true),
                (record.refund_status == 1 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "部分退款"))
                  : _createCommentVNode("", true),
                (record.refund_status == 2 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "全部退款"))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'discount_price' && record.info !== null )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                _createTextVNode(_toDisplayString(record.info.discount_price), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'total_price' && record.info !== null )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                _createTextVNode(_toDisplayString(record.info.total_price), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'total_pay_price' && record.info !== null )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                _createTextVNode(_toDisplayString(record.info.total_pay_price), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination", "onChange"])
    ]),
    _: 1
  }))
}